import React, { useEffect, useState } from "react";
import axios from "axios";
import { Quote, Star } from "lucide-react";
import { useLang } from "../LanguageContext";
import EditableI18n from "./EditableI18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function TestimonialsCarousel() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data.testimonials || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const i = setInterval(() => setIdx((x) => (x + 1) % items.length), 7000);
    return () => clearInterval(i);
  }, [items.length]);

  if (items.length === 0) return null;
  const cur = items[idx];

  return (
    <section data-testid="testimonials-section" className="px-6 md:px-12 lg:px-20 py-24 md:py-32 border-y border-border bg-muted/20">
      <div className="max-w-3xl mx-auto text-center">
        <p className="qw-overline mb-4"><EditableI18n k="testimonials.overline" label="Testimonials overline" /></p>
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-12 font-light">
          <EditableI18n k="testimonials.title" label="Testimonials title" />
        </h2>
        <Quote size={36} strokeWidth={0.8} className="text-primary mx-auto mb-8" />
        <p
          key={cur.id}
          data-testid={`testimonial-${cur.id}`}
          className="qw-fade-in font-serif text-2xl md:text-3xl text-foreground/95 leading-relaxed italic mb-8"
        >
          "{cur.text}"
        </p>
        <div className="flex items-center justify-center gap-1 mb-3">
          {Array.from({ length: cur.rating || 5 }).map((_, i) => (
            <Star key={i} size={14} strokeWidth={1.2} className="text-primary fill-primary" />
          ))}
        </div>
        <p className="qw-overline">{cur.name}{cur.service ? ` · ${cur.service}` : ""}</p>
        {items.length > 1 && (
          <div className="flex justify-center gap-2 mt-10">
            {items.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Testimonial ${i + 1}`}
                className={`h-px transition-all duration-500 ${i === idx ? "w-10 bg-primary" : "w-4 bg-border"}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
